import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { contatoKeyToLabel } from "../../../detalhes-do-projeto/filtros/contatos";
import { IContato } from "../../../../../../../application/models";
// Icon
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';

export const RecorteContatoFilterPreview = (props: {
    contatoFilter?: IContato[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Contatos
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.contatoFilter && props.contatoFilter.map((contato, i) => (
                                <Chip
                                    key={i}
                                    icon={<ConnectWithoutContactIcon />}
                                    label={contatoKeyToLabel(contato).toUpperCase()}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}